import type { WordTargets } from "../types";

export const MIN_WORDS_PER_MINUTE = 120;
export const TARGET_WORDS_PER_MINUTE = 133.333;
export const MAX_WORDS_PER_MINUTE = 146.667;
export const OUTER_TOLERANCE_WORDS = 100;

export function calculateWordTargets(minutes: number): WordTargets {
  const wholeMinutes = Math.max(1, Math.round(minutes));
  const minimumWords = Math.round(wholeMinutes * MIN_WORDS_PER_MINUTE);
  const targetWords = Math.round(wholeMinutes * TARGET_WORDS_PER_MINUTE);
  const maximumWords = Math.round(wholeMinutes * MAX_WORDS_PER_MINUTE);

  return {
    minutes: wholeMinutes,
    minimumWords,
    targetWords,
    maximumWords,
    permittedMinimumWords: Math.max(1, minimumWords - OUTER_TOLERANCE_WORDS),
    permittedMaximumWords: maximumWords + OUTER_TOLERANCE_WORDS,
  };
}

export function formatWordRange(targets: WordTargets): string {
  return `${targets.minimumWords.toLocaleString()}-${targets.maximumWords.toLocaleString()} words`;
}
